export default "__VITE_ASSET__Bd_TJCSw__"